import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import TkWireCamSuperDrillDialog from "../dialogTypes/TkWireCamSuperDrillDialog";
import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";

function TkUpdateWireSuperDrillButton ( props ) {

    const { t } = useTranslation();

    const { id, grid, refresh, onSelectMst, onSelectDetail, processCode, onSuccess, processName, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    const [customWireSchema, setCustomWireSchema] = useState();

    useEffect(()=> {

        let schema = {

            name: "WireWork",
            type: "BASE TABLE",
            searchAll: false,
            columns: [
    
                {
                    name: "num",
                    type: "int(11)",
                    formOrder: 1,
                    formItemType: "number",
                    required : true,
                },
                /* {
                    name: "workTime",
                    type: "int(11)",
                    formOrder: 5,
                    required : true,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "TimeToSecond",
                        nameColumn: ["timeName"],
                        valueColumn: "second",
                    },
                }, */
                /* {
                    name: "workers",
                    formOrder: 10,
                    hideInForm: false,
                    formGroup: 0,
                    formItemType: "multipleAutocomplete",
                    required : true,
                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        useEmptyValue: false,
                        sortByName: true,
                    },
                    width : "100%"
                }, */
    
            ]
        };
        
        setCustomWireSchema(schema);

    },[])

    const onOpen = () => {

        if (grid) {

            let selectData = { ...(grid.selectedItems[0]) }
            let returnObj = {};

            for (let column in selectData) {

                switch(column) {

                    case "workerId" :

                        if( selectData[column] ) {

                            let workerArray = [];
                            let workerValues = selectData[column]?.split(",");
                            let workerName = selectData["workers"]?.split(",");
        
                            for (let [index, value] of workerValues?.entries()) {
        
                                workerArray.push({ name: workerName[index], value: value })
                            
                            }
        
                            returnObj["workers"] = workerArray;

                        }


                    break;

                    /* case "workTime" :

                        let hms = selectData[column];
                        let hmsSplit = hms.split(':');
                        var seconds = (+hmsSplit[0]) * 60 * 60 + (+hmsSplit[1]) * 60 + (+hmsSplit[2]);

                        returnObj[column] = seconds || 1800;
                    
                    break; */

                    case "workers" :

                    break;

                    default :

                        returnObj[column] = selectData[column];

                    break;

                }
            }

            setFormData({ ...returnObj });
        }

        setOpen(true);

    };
    const onClose = () => {

        setOpen ( false );

    };

    const onUpdateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        refresh.refresh ();

    };

    return (

        <>
            <UpdateRecordButtonLayout id={id + "update-button"} onClick={onOpen} {...others} />
            <TkWireCamSuperDrillDialog
                id={id+"update-tkwire-dialog"}
                mode="edit"
                formId={id+"update-tkwire-form"}
                title={customWireSchema ? t(`dialog.title.${id}.wireCamSuperDrill.update`) : ""}
                schema = {customWireSchema}
                onSelectMst = {onSelectMst}
                onSelectDetail = {onSelectDetail}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
            />
        </>

    );
}

export default TkUpdateWireSuperDrillButton;

